import { School, SchoolType } from "@interfaces/school"
import SchoolServices from "@services/school.services"
import { useLayoutEffect, useState } from "react"

export function useSchools(type: SchoolType) {
  const [data, setData] = useState<School[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useLayoutEffect(() => {
    const fetcher = async () => {
      const school = new SchoolServices()
      try {
        const res = await school.getSchoolList(type)

        if (res.isSuccess) {
          const result = res.getValue()
          setData(result.data)
        }

        setIsLoading(false)
      } catch (e) {
        setIsLoading(false)
      }
    }

    fetcher()
  }, [])

  return { data, isLoading }
}
